// @ts-nocheck
import React, { useState, FC } from 'react';
import { createUserWithEmailAndPassword } from "firebase/auth";
import { whichAuth as getAuth } from '../../getAuth';
import { useSetRecoilState } from 'recoil';
import { showSignInState } from '../../atoms';
import {
  IonContent,
  IonButton,
  IonList,
  IonItem,
  IonInput,
  IonSpinner,
  IonCardContent,
  IonLabel,
  IonCardSubtitle,
  IonCheckbox,
  IonCardHeader,
} from '@ionic/react';
import { REST_API_URL } from '../../constants/global';
import { validationEmail } from "../../utils/validationEmail";
import { AlertModal } from "../../components";

const SignUp: FC = () => {
  
  const setShowSignIn = useSetRecoilState(showSignInState);
  const emailProvided = new URLSearchParams(window.location.search).get('email');
  
  const [email, setEmail] = useState<string>(emailProvided || '');
  const [password, setPassword] = useState<string>('');

  const [inProgress, setInProgress] = useState<boolean>(false);
  const [showError, setShowError] = useState<boolean>(false);
  const [errorCode, setErrorCode] = useState<string>('');
  const defaultError = 'An error occured creating your account.';
  const [errorMessage, setErrorMessage] = useState<string>(defaultError);
  const [checked, setChecked] = useState<boolean>(false);

  const createUser = async () => {
    setInProgress(true);
    try {
      await createUserWithEmailAndPassword(getAuth(), email, password)
    } catch (error) {
      setErrorCode(error.code);
      setErrorMessage(createErrorMessage(error));
      setShowError(true);
    } finally {
      setTimeout(() => setInProgress(false), 1000)
    }
  };
  
  const createErrorMessage = error => {
    switch(error.code) {
      case 'auth/email-already-in-use': return 'An account with email address ' + email + ' already exists. Please sign in.';
      default: return error.message || defaultError;
    }
  }

  return (
    <IonContent fullscreen>
      <IonCardContent className="h-full card-authentication">
        <IonCardContent className="left-authentication" />
        <IonCardContent className="right-authentication">
          <IonList lines="none" className="right-list-authentication">
            <IonCardHeader className="logo-authentication" />
            <IonCardSubtitle className="header-authentication">
              Sign Up
            </IonCardSubtitle>
            
            { /*
            <IonLabel className="label-authentication">Email</IonLabel>
            <IonItem fill="outline" className="no-padding">
              <IonInput
                className="input-authentication"
                onIonChange={event => setEmail(event.detail.value)}
                value={email}
                type="email"
                required
              />
            </IonItem>
            <IonLabel className="label-authentication">Password</IonLabel>
            <IonItem fill="outline" className="no-padding">
              <IonInput
                className="input-authentication"
                onIonChange={event => setPassword(event.detail.value)}
                type="password"
                required
              />
            </IonItem>
            <div className="agree-authentication no-padding">
              <IonCheckbox checked={checked} className="checked-authentication" onIonChange={e => setChecked(e.detail.checked)} />
              I agree to the<a className="link-authentication" href="https://billsmoov.com.au/terms/" target="_blank">Terms</a>
              and <a className="link-authentication" href="https://billsmoov.com.au/privacy/" target="_blank">Privacy Policy</a>
            </div>
            <IonItem className="no-padding">
              <IonButton
                size="medium"
                disabled={!password || validationEmail(email) || !checked}
                onClick={createUser}
                className="button-authentication"
              >
                { inProgress && <IonSpinner name="dots" /> } Create account
              </IonButton>
            </IonItem> 
            */ }
            
            <IonItem>
              <p style={{textAlign:'justify', padding:'0px', margin:'0px 0px 25px 0px'}}>
                We are not accepting any more sign ups at this time.  Please join our waitlist to be notified when we onboard our next round of users.
              </p>
            </IonItem>
            <IonItem className="no-padding">
              <IonButton
                size="medium"
                href="https://billsmoov.com.au/waitlist/"
                className="button-authentication">
                Join the waiting list
              </IonButton>
            </IonItem>
            
            
            <IonItem className="already-authentication no-padding">
              Already have an account?
              <a className="link-authentication" onClick={() => setShowSignIn(true)}>Sign in</a>
            </IonItem>
          </IonList>
        </IonCardContent>
      </IonCardContent>
      <AlertModal
        isOpen={showError}
        title="Sign Up failed"
        subTitle={errorMessage || defaultError}
        onClosed={() => {
          setShowError(false)
          if(errorCode === 'auth/email-already-in-use') {
            setShowSignIn(true);
          }
        }}
      />
    </IonContent>
);}

export default SignUp;
